import * as React from 'react';
import type { AllCMSPageFields } from '@/cms/fields/mappers/common';

export const PageFieldsContext = React.createContext<AllCMSPageFields | null>(null);

export const PageFieldsProvider = PageFieldsContext.Provider;
